export const FILE_FORMATS = [
  '.txt',
  '.doc',
  '.ppt',
  '.pptx',
  '.docx',
  '.csv',
  '.xls',
  '.xlsx',
  '.pdf',
];

export const MAX_SIZE_BYTES = 32 * 1024 * 1024; //32MB
